var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        placement: _vm.placement,
        trigger: _vm.trigger,
        overlayClassName: ["supsis-popover", _vm.className].flat().join(" "),
      },
      scopedSlots: _vm._u(
        [
          {
            key: "content",
            fn: function () {
              return [_vm._t("popover-content")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _vm._t("content")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }